export const getLocalStorageItem = <TItem = unknown>(
  key: string
): TItem | null => {
  const value = localStorage.getItem(key)
  return value == null ? null : JSON.parse(value)
}
export const setLocalStorageItem = (key: string, value: string): void => {
  localStorage.setItem(key, value)
}
export const removeLocalStorageItem = (key: string): void => {
  localStorage.removeItem(key)
}
